import React, { Component, PropTypes } from 'react';
import Promise from 'bluebird';
import CTModal from '../helpers/CTModal';

class DialogModalWithChild extends Component {
    constructor(props) {
        super(props);
        this.promiseDelegates = {
            resolve: () => {},
            reject: () => {}
        };
        this.state = {
            isOpen: false
        };
    }
    ask = (primaryButtonAction, secondaryButtonAction) => {
        this.props.onOpen();

        this.setState({
            isOpen: true
        });
        const askPromise = new Promise((resolve, reject) => {
            this.promiseDelegates.resolve = resolve;
            this.promiseDelegates.reject = reject;
        }).then(() => Promise.method(primaryButtonAction)(), secondaryButtonAction);

        return askPromise;
    };
    answer = value => {
        this.setState({
            isOpen: false
        });

        value ? this.promiseDelegates.resolve(value) : this.promiseDelegates.reject(value);
    };

    primaryButtonClick = () => this.answer(true);

    secondaryButtonClick = () => this.answer(false);

    render() {
        return (
            <CTModal
                open={this.state.isOpen}
                primaryButtonTitle={this.props.primaryButtonTitle}
                primaryButton={this.props.primaryButton}
                primaryButtonClick={this.primaryButtonClick}
                primaryButtonDisabled={this.props.primaryButtonDisabled}
                secondaryButton={this.props.secondaryButton}
                secondaryButtonClick={this.secondaryButtonClick}
                secondaryButtonTitle={this.props.secondaryButtonTitle}
                onClose={this.primaryButtonClick}
            >
                {this.state.isOpen && (
                    <div>
                        <h4 style={{ marginBottom: 12 }}>{this.props.title}</h4>
                        <div className="col-xs" style={{ marginBottom: 50 }}>
                            {this.props.children}
                        </div>
                    </div>
                )}
            </CTModal>
        );
    }
}

DialogModalWithChild.defaultProps = {
    primaryButtonTitle: 'Save',
    primaryButton: true,
    primaryButtonDisabled: false,
    secondaryButton: true,
    secondaryButtonTitle: 'Cancel',
    onOpen: () => {}
};

DialogModalWithChild.propTypes = {
    primaryButtonTitle: PropTypes.string,
    primaryButton: PropTypes.bool,
    primaryButtonDisabled: PropTypes.bool,
    secondaryButton: PropTypes.bool,
    secondaryButtonTitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    children: PropTypes.shape({}),
    onOpen: PropTypes.func
};

export { DialogModalWithChild };



// WEBPACK FOOTER //
// ./src/components/modals/DialogModalWithChild.js